import React from 'react'
import { SvgIcon, SxProps } from '@mui/material'

interface Props {
  sx?: SxProps
  [prop: string]: any
}

export const SeenIcon = ({ sx, ...props }: Props) => (
  <SvgIcon
    viewBox="0 0 20 14"
    sx={{ width: '20px', height: '14px', color: 'primary300', ...sx }}
    {...props}
  >
    <path
      d="M9.49959 8.5L8.49959 9.58333L10.6663 11.6667V11.75L19.0829 3.33333L17.9996 2.25L10.6663 9.58333L9.49959 8.5ZM5.08293 11.6667V11.75L13.4996 3.33333L12.4163 2.25L5.08293 9.58333L1.99959 6.5L0.91626 7.58333L5.08293 11.6667Z"
      fill="inherit"
    />
  </SvgIcon>
)

SeenIcon.defaultProps = {
  sx: null,
}
